module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Dottikon-bca97997595eedbcd98954cffa64115e.svg";